import { Tag } from 'antd';

/** Хоосон утгыг "-" болгож харуулна */
export const val = (value) => (value === null || value === undefined || value === '' ? '-' : value);

/**
 * Барааны дэлгэцүүдийн `Descriptions`-ийн ерөнхий тохиргоо: label дээр, утга
 * доор, зай багатай. `column`-ыг дуудаж байгаа тал өөрөө өгнө.
 */
export const descriptionProps = {
  size: 'small',
  colon: false,
  layout: 'vertical',
  labelStyle: { paddingBottom: 0 },
  contentStyle: { paddingBottom: 8 },
};

/** Тийм / Үгүй-г tag-аар */
export const YesNo = ({ value }) =>
  value === true ? <Tag color="green">Тийм</Tag> : <Tag>Үгүй</Tag>;
